import arrow from '../../images/arrow-long.png';

export default function initializeSingleMap() {
    if ( !document.querySelector('#map-single') ){
        return false;
    }

    var lat = document.querySelector('#map-single').dataset.lat;
    var lng = document.querySelector('#map-single').dataset.lng;
    var marker = document.querySelector('#map-single').dataset.marker;

    const cities = L.layerGroup();

    var icon = L.icon({
        iconUrl: marker,
        shadowUrl: '',

        iconSize:     [24, 32],
        shadowSize:   [0, 0],
        iconAnchor:   [0, 0],
        shadowAnchor: [0, 0],
        popupAnchor:  [12, 0]
    });

    var marker = L.marker([lat, lng], {icon: icon});

    const osm = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19
    });

    var pc = true;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        pc = false;
    }


    const map = L.map('map-single', {
        center: [lat, lng],
        zoom: 10,
        scrollWheelZoom: false,
        dragging: pc,
        layers: [osm, cities]
    });

    const baseLayers = {
        'OpenStreetMap': osm,
    };

    const overlays = {
        'Cities': cities
    };

    marker.addTo(map);

}
